var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowBgGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C4FCBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3185 16.3189C11.3185 16.7331 11.6543 17.0689 12.0685 17.0689C12.4828 17.0689 12.8185 16.7331 12.8185 16.3189L11.3185 16.3189ZM12.8185 16.3189L12.8185 7.68107L11.3185 7.68107L11.3185 16.3189L12.8185 16.3189Z",
    fill: "#138D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06854 11.5638L11.9512 7.68107",
    stroke: "#138D00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0491 7.68136L15.9318 11.564",
    stroke: "#138D00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowBgGreenIcon);
export default __webpack_public_path__ + "static/media/upArrow-bg-green-icon.95a240ebfcde0dce83e39bf9b81020d3.svg";
export { ForwardRef as ReactComponent };